import { AdditionServicesOptionsState } from '@pages/AdditionalServices/containers/additionServicesOptionsContext';
import {
  AServiceCache,
  AServicePropertyCache,
  AServicePropertyFilterAndOrder,
  AdditionServicesState,
} from '@pages/AdditionalServices/containers/types';

import { ServiceData, SetUpServiceData } from '../../../basket/types';
import { calculateFieldValues } from '../../../calculateFieldValues';
import { serviceRestoreStateGeneratorProcessor } from '../types';

/**
 * InitialVariantFieldsProcessor формирует начальные значения полей услуг.
 */
export class InitialVariantFieldsProcessor implements serviceRestoreStateGeneratorProcessor {
  /**
   * restore выполняет восстановление стейтов. Возвращает все стейты.
   * @param _
   * @param __
   * @param additionalServiceState
   * @param optionsState
   * @param serviceCacheState
   * @param servicePropertyCacheState
   * @param servicePropertyFilterAndOrderState
   */
  async restore(
    _: SetUpServiceData,
    __: (SetUpServiceData | ServiceData)[],
    additionalServiceState: AdditionServicesState,
    optionsState: AdditionServicesOptionsState,
    serviceCacheState: AServiceCache,
    servicePropertyCacheState: AServicePropertyCache,
    servicePropertyFilterAndOrderState: AServicePropertyFilterAndOrder
  ) {
    const variantFieldValues = Object.values(additionalServiceState.VariantFieldValues);

    const fieldsList = Object.values(additionalServiceState.VariantFields)
      .flat(1)
      .sort((a, b) => (a.id < b.id ? 1 : -1));

    const fieldValues: { [T in string]: number } = {};
    fieldsList.map((f) => {
      fieldValues[f.code] = variantFieldValues[f.code] ?? f.value ?? 0;
    });

    const calculatedFieldValues = calculateFieldValues(fieldsList, fieldValues, {}, undefined, additionalServiceState.FieldValues);

    const values: { [T in string]: { [T in string]: number } } = {};

    Object.entries(additionalServiceState.VariantFields).forEach(([key, value]) => {
      if (value.length === 0) {
        values[key] = {};
        return;
      }

      value.forEach((field) => {
        if (values[key]) {
          values[key][field.code] = calculatedFieldValues[field.code];
          return;
        }

        values[key] = { [field.code]: calculatedFieldValues[field.code] };
      });
    });

    return {
      isValid: true,
      additionalServiceState: {
        ...additionalServiceState,
        VariantFieldValues: values,
      },
      optionsState,
      serviceCacheState,
      servicePropertyCacheState,
      servicePropertyFilterAndOrderState,
    };
  }
}
